import { render } from "./faq.vue?vue&type=template&id=2a84364e"
const script = {}
script.render = render

export default script